import React from "react";
export function PulseDot({
  className = ""
}: {
  className?: string;
}) {
  return <span className={`relative inline-flex h-2.5 w-2.5 shrink-0 ${className}`} aria-hidden="true" data-id="element-430" data-mp="26opy3w24uj1c">
      <span className="pulse-ring absolute inset-0 rounded-full bg-live" data-id="element-431" data-mp="1spgtzur7bfdq" />
      <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-live" data-id="element-432" data-mp="1srjj8ckj54he" />
    </span>;
}